import Loading from '../../../Common/Loading';
import { useHouseHoldVisitChartsDataContext } from './hooks/useHouseHoldVisitChartsDataContext';
import { Indicators } from './Indicators';
import { MonthlyEvolutionHouseHoldVisit } from './MonthlyEvolutionHouseHoldVisit';
import { AnnualEvolutionHouseHoldVisit } from './AnnualEvolutionHouseHoldVisit';
import EvolutionHouseVisitByCoordinates from './EvolutionHouseVisitByCoordinates';
import { EvolutionByHouseHoldStatus } from './EvolutionByHouseHoldStatus';

export const Charts = () => {
    const { isLoading } = useHouseHoldVisitChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionHouseHoldVisit />
                <EvolutionByHouseHoldStatus />
            </div>
            <div className="charts-side-by-side-dashboards">
                <EvolutionHouseVisitByCoordinates />
            </div>
            <div className="w-100">
                <MonthlyEvolutionHouseHoldVisit />
            </div>
        </>
    );
};
